import { instance } from "libs/api";

import { ApiRoutesEarnings } from "../../constants";
import { PayEarningsBody } from "./payEarnings.types";

export const requestPayEarnings = async (
  body: PayEarningsBody
): Promise<void> => {
  return await instance.patch(ApiRoutesEarnings.PayEarnings, body);
};
